module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("04U9J"))).then(() => module.bundle.root('ljYL6'));